import loadSentry from './sentry';
import loadFontAwesome from './font-awesome';

const loaders = () => {
  loadSentry();
  loadFontAwesome();
};

export default loaders;
